import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import { IMAGE_DIMENSION } from 'constants/constants';
import useRefresh from 'hooks/useRefresh';

const ImageLoader = (props) => {
  const { src, size, tag, objectFit } = props;
  const { fastRefresh } = useRefresh();

  const [loading, setLoading] = useState(true);
  const [loadFail, setLoadFail] = useState(false);
  const [idGenerate, setIdGenerate] = useState(
    `id${Math.random().toString(16).slice(2)}`,
  );

  const TagImage = tag || Image;

  useEffect(() => {
    if (src) {
      setLoading(true);
      setLoadFail(false);
    }
  }, [
    typeof src === 'object'
      ? src[IMAGE_DIMENSION[size] || IMAGE_DIMENSION.root]
      : src,
  ]);

  useEffect(() => {
    if (document.getElementById(idGenerate)?.complete && loading) {
      setLoading(false);
    }
  }, [fastRefresh]);

  return (
    <TagImage
      priority
      id={idGenerate}
      loading="eager"
      onLoad={() => setLoading(false)}
      onError={() => setLoadFail(true)}
      {...props}
      {...(typeof src === 'object'
        ? {
            src: src[IMAGE_DIMENSION[size] || IMAGE_DIMENSION.root],
          }
        : {})}
      {...(loading
        ? {
            src: '/images/Loading2.gif',
            objectFit: objectFit ?? 'cover',
          }
        : {})}
      {...(loadFail
        ? {
            src: '/images/noimageavailable.png',
            objectFit: objectFit ?? 'contain',
          }
        : {})}
    />
  );
};

export default ImageLoader;
